import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbFormattedDateString,
    bbGetArrayOfBreachAttackIdsFromCampaigns,
    bbGetArrayOfBreachAttackIdsFromVectors,
    bbShortenString,
    filterObject,

} from "../../../../util/bbHelpers";
import {
    fetchAttackAction,
    fetchCampaignsAction,
    fetchCustomers,
    fetchVectorsAction,
} from "../../../../actions";
import ArrayDataTable from "../../tables/ArrayDataTable";
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import BBIconJollyRogerSkull from "../../../../assets/bbCustomIcons/BBIconJollyRogerSkull";
import BBIconWarningTriangle from "../../../../assets/bbCustomIcons/BBIconWarningTriangle";
import {Badge} from "reactstrap";

// const useStyles = makeStyles((theme) => ({
//     button: {
//         margin: theme.spacing(1),
//     },
// }));

const TableContainer = (props) => {

    const {customerId, past = false, current = false} = props;

    const typeTitle = past ? current ? "CIRT Breaches" : "Past CIRT Breaches" : current ? "Ongoing CIRT Breaches Breaches" : "CIRT Breaches";

  // const [activeTab, setActiveTab] = useState('1');
  //
  // const classes = useStyles();
  // const handleChangeTab = (event, newTab) => {
  //   setActiveTab(newTab);
  // }

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, loadingAttack, loadingAttackError, metaCampaigns, loadingCampaigns, customerInView, loadingVectors} = useSelector(({customer}) => customer);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customers[customerId] ? customers[customerId] : null : null;
  //from the customer, pull the target data if it exists
  const vectors = customer ? customer.vectors ? customer.vectors : null : null;
    const campaigns = customer ? customer.campaigns ? customer.campaigns : null : null;
  // const active = targets ? filterObject(targets, (_, target) => target.Vulnerabilities && target.IsActive !== false) : null;
  // const totalNumVulnTargets = (metaTargets && metaTargets[customer.CustomerId] && metaTargets[customer.CustomerId].targets_with_vulns) ? metaTargets[customer.CustomerId].targets_with_vulns : null;
    const vectorBreachAttackIdsArray = bbGetArrayOfBreachAttackIdsFromVectors(vectors, past, current);
    const campaignBreachAttackIdsArray = bbGetArrayOfBreachAttackIdsFromCampaigns(metaCampaigns, customerId, past, current);
    const breachAttackIdsArray = (vectorBreachAttackIdsArray && campaignBreachAttackIdsArray) ? [...vectorBreachAttackIdsArray, ...campaignBreachAttackIdsArray] : [];
    const [breachAttacks, setBreachAttacks] = useState(null);
    const [thisBreachDataIsForCustomerId, setThisBreachDataIsForCustomerId] = useState(null);
    const totalNumBreaches = breachAttackIdsArray ? breachAttackIdsArray.length : null;
    const targetsBatchSize = 10;
    const [localLoading, setLocalLoading] = useState(true)

  useEffect(() => {
      //check to see if any data loaded is for the current customer (or null)
      if (thisBreachDataIsForCustomerId !== customerId && (!!thisBreachDataIsForCustomerId && !!breachAttacks)) {
          setLocalLoading(true);
          setBreachAttacks(null);
          setThisBreachDataIsForCustomerId(null);
      }

    // console.group("VulnTargets Table for customerId: ", customerId, " customer: ", customer, " targets: ", targets)
    // console.log("VulnTargets here is the customers in the store", customers)
    if (customers == null && !loadingCustomers) {
      // console.log("Customers is empty, fetching.")
      dispatch(fetchCustomers());
    }

    //get vector data
      if (customer && vectors === null && !loadingVectors) {
          // console.log("targets is empty, fetching targets for customerId = ", customer.CustomerId);
          dispatch(fetchVectorsAction({
              customerId: customer.CustomerId
          }));
      }

      //get campaign data
      if (customer && campaigns === null && !loadingCampaigns) {
          // console.log("targets is empty, fetching targets for customerId = ", customer.CustomerId);
          dispatch(fetchCampaignsAction({
              customerId: customer.CustomerId
          }));
      }

      // console.log(`Checking before building missing attacks: `, breachAttackIdsArray, customers, vectors, metaCampaigns, campaigns)
    if (breachAttackIdsArray && customers && vectors && metaCampaigns && campaigns && !loadingCustomers && !loadingVectors && !loadingCampaigns) {
        //if the array is not null, then it has been fetched from vectors.
        //check to see which attacks are not in the state, and need to be fetched.


        //vectors
        const vectorAttacksOnHand = {}
        for (const [vectorId, vector] of Object.entries(vectors)) {
            //take the attacks and add them to the attacks on hand
            if (vector.Attacks) {
                //check each attack to make sure its detailed
                for (const [attackId, attack] of Object.entries(vector.Attacks)) {
                    if (attack.hasOwnProperty("Perimeter Attack Detail")) {
                        vectorAttacksOnHand[attackId] = attack;
                    }
                }
            }
        }
        const vectorAttacksOnHandIds = Object.keys(vectorAttacksOnHand);

        const missingVectorIds = vectorBreachAttackIdsArray.filter((item) => {
            return !vectorAttacksOnHandIds.includes(item);
        })

        //campaigns
        const campaignAttacksOnHand = {}
        for (const [campaignId, campaign] of Object.entries(campaigns)) {
            //take the attacks and add them to the attacks on hand
            if (campaign.Attacks) {
                //check each attack to make sure its detailed
                for (const [attackId, attack] of Object.entries(campaign.Attacks)) {
                    if (attack.hasOwnProperty("Phishing Attack Detail")) {
                        campaignAttacksOnHand[attackId] = attack;
                    }
                }
            }
        }
        const campaignAttacksOnHandIds = Object.keys(campaignAttacksOnHand);
        const missingCampaignIds = campaignBreachAttackIdsArray.filter((item) => {
            return !campaignAttacksOnHandIds.includes(item);
        })

        // const attacksMissing = breachAttackIdsArray.filter((item) => {
        //     return !attacksOnHandIds.includes(item);
        // })

        const attacksMissing = [...missingVectorIds, ...missingCampaignIds]

        // console.log("Just checked for missing attacks. breachAttackIdsArray", breachAttackIdsArray, "missingVectorIds", missingVectorIds, "missingCampaignIds", missingCampaignIds, "attacksMissing", attacksMissing, "vectorAttacksOnHand", vectorAttacksOnHand, "campaignAttacksOnHand", campaignAttacksOnHand);

        if (attacksMissing.length <= 0) {
            //nothing is missing, loading is done
            //compile all breach attacks
            const allAttackObjects = {}
            Object.assign(allAttackObjects, vectorAttacksOnHand, campaignAttacksOnHand);
            // console.log("allAttackObjects is", allAttackObjects);
            //remove anything that isn't a breach attack
            const breachAttackObjects = filterObject(allAttackObjects, (attackId, attack) => breachAttackIdsArray.includes(attackId));
            // console.log("breachAttackObjects is", breachAttackObjects);

            //stuff in the state
            setBreachAttacks(breachAttackObjects);
            setThisBreachDataIsForCustomerId(customerId);
            setLocalLoading(false);
            // console.log("Stopped local loading and set breach attacks to ", breachAttackObjects);
        } else {
            //still work to do.  fetch one at a time.
            console.group("Still missing some attacks.  attacksMissing", attacksMissing)
            //go through campaigns first
            if (missingCampaignIds.length > 0 ) {
                const idToFetch = missingCampaignIds[0];
                //go back and find this attack ID in the campaigns set
                // let campaignIdToFetch = null;
                // // console.log("Going into campaigns to look for ", idToFetch);
                // for (const [campaignId, campaign] of Object.entries(campaigns)) {
                //     // console.group("Checking Campaign ", campaignId);
                //     if (campaign.Attacks){
                //         for (const [attackId, attack] of Object.entries(campaign.Attacks)) {
                //             // console.group("Checking Attack ", attackId, attack);
                //             if (attackId === idToFetch) {
                //
                //                 campaignIdToFetch = campaignId;
                //                 // console.log("Found it. campaignIdToFetch now ", campaignIdToFetch);
                //                 // console.groupEnd();
                //                 break;
                //             }
                //             // console.groupEnd()
                //         }
                //     }
                //     if (campaignIdToFetch) {
                //         // console.groupEnd();
                //         break;
                //     }
                //     console.groupEnd();
                // }
                // if (idToFetch && campaignIdToFetch && !loadingAttack) {
                if (campaigns && idToFetch && !loadingAttack) {
                    console.log(`Fetching attack ${idToFetch}` , "for campaign");
                    setLocalLoading(true);
                    dispatch(fetchAttackAction({
                        customerId: customerId,
                        attackId: idToFetch,
                        // campaignId: campaignIdToFetch
                    }))
                }
            } else if (missingVectorIds.length > 0 ) {
                const idToFetch = missingVectorIds[0];
                //go back and find this attack ID in the campaigns set
                // let vectorIdToFetch = null;
                // // console.log("Going into campaigns to look for ", idToFetch);
                // for (const [vectorId, vector] of Object.entries(vectors)) {
                //     // console.group("Checking Vector ", vectorId);
                //     if (vector.Attacks){
                //         for (const [attackId, attack] of Object.entries(vector.Attacks)) {
                //             // console.group("Checking Attack ", attackId, attack);
                //             if (attackId === idToFetch) {
                //                 vectorIdToFetch = vectorId;
                //                 // console.log("Found it. vectorIdToFetch now ", vectorIdToFetch);
                //                 // console.groupEnd();
                //                 break;
                //             }
                //             // console.groupEnd()
                //         }
                //     }
                //     if (vectorIdToFetch) {
                //         // console.groupEnd();
                //         break;
                //     }
                    // console.groupEnd();
                // }
                // if (idToFetch && vectorIdToFetch && !loadingAttack) {
                if (vectors && idToFetch  && !loadingAttack) {
                    console.log(`Fetching attack ${idToFetch}` , "for vector");
                    setLocalLoading(true);
                    dispatch(fetchAttackAction({
                        customerId: customerId,
                        attackId: idToFetch
                    }))
                }
            }

            console.groupEnd();
        }
    }
  }, [customerId, customers, customerInView, vectors, campaigns, metaCampaigns, dispatch, loadingVectors, loadingCustomers, loadingAttack, loadingAttackError,
            // breachAttacks, campaignBreachAttackIdsArray, customer, loadingCampaigns, thisBreachDataIsForCustomerId, vectorBreachAttackIdsArray
  ]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div id={"BreachesTable"} className={"tourStepBreachesTable"}>
        {typeTitle} <Tooltip title={"CIRT attacks that caused a breach. A breach is a violation of the confidentiality, integrity, and/or availability of your data or services."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

  const userTableHeadings = [
      // "Breach",
      "Date",
      "Status",
      "Description",
      "Origin",
      "Target"
  ];

    //peel the state data into a form the dataTable can read
  const customDataMap = (item) => {
      // console.log("Mapping over customDataMap item ", item)
      // console.log("Analyzing item for breaches table: ", item);
      // console.log("(item[\"Perimeter Attack Detail\"] && item[\"Perimeter Attack Detail\"][\"Attack Vector\"]) is",(item["Perimeter Attack Detail"] && item["Perimeter Attack Detail"].hasOwnProperty("Attack Vector")));
      if (item["Perimeter Attack Detail"] && item["Perimeter Attack Detail"].hasOwnProperty("Attack Vector")){
          // console.log("item[\"Perimeter Attack Detail\"][\"Attack Vector\"] is", item["Perimeter Attack Detail"]["Attack Vector"])
          // console.log("item[\"Perimeter Attack Detail\"][\"Attack Vector\"][\"Fqdn\"] is", item["Perimeter Attack Detail"]["Attack Vector"]["Fqdn"])
      }

      const statusIcon = () => {
          // Attempted
          // Ongoing
          // Partially Successful
          // Successful
          // Aborted (BreachBits)
          // Aborted (Customer)
          switch (item.Status.Name){
              case "Ongoing" :
                  return <div className={"text-center"}><BBIconWarningTriangle className={"text-bb-risk-highest"} style={{fontSize: "3em"}}/><br/><Badge color="bb-risk-highest">ONGOING</Badge></div>
              case "Partially Successful" :
                  return <div className={"text-center"}><BBIconJollyRogerSkull className={"text-bb-risk-high"}/><br/><Badge color="bb-risk-high">Partial</Badge></div>
              case "Successful" :
                  return <div className={"text-center"}><BBIconJollyRogerSkull className={"text-bb-risk-highest"} style={{fontSize: "2.5em"}}/></div>
              default:
                  return <div className={"text-center"}><BBIconJollyRogerSkull className={"text-info"}/></div>
          }
      }

      //detailed and summary objects have a different structure
      const isBasicItem = item.hasOwnProperty("Details")
      const isVector = !!item.PerimeterAttackId

      const originComponent = isVector
        ? isBasicItem //vector
          ? <Tooltip title={item.Details["Attack Origin Ip Address"]}><span>{bbShortenString(item.Details["Attack Origin Ip Address"] , 25, true)}</span></Tooltip>
          : <Tooltip title={item["Perimeter Attack Detail"]["Attack Origination Ip"]}><span>{bbShortenString(item["Perimeter Attack Detail"]["Attack Origination Ip"] , 25, true)}</span></Tooltip>
        : isBasicItem && !item["Phishing Attack Detail"]//campaign
            ? <Tooltip title={item.Details["Source Email Address"] }><span>{bbShortenString(item.Details["Source Email Address"] , 25, true)}</span></Tooltip>
            : <Tooltip title={item["Phishing Attack Detail"]["Phishing Profile"]["Sender"]["Username"] }><span>{bbShortenString(item["Phishing Attack Detail"]["Phishing Profile"]["Sender"]["Username"] , 25, true)}</span></Tooltip>

      const targetComponent = isVector
          ? isBasicItem //vector
              ? <Tooltip title={"Fetch Details..."}><span>{bbShortenString("Fetch Details..." , 25, true)}</span></Tooltip>
              : <Tooltip title={item["Perimeter Attack Detail"]["Attack Vector"]["Fqdn"]}><span>{bbShortenString(item["Perimeter Attack Detail"]["Attack Vector"]["Fqdn"] , 25, true)}</span></Tooltip>
          : isBasicItem && !item["Phishing Attack Detail"]//campaign
              ? <Tooltip title={item.Details["Target Email Address"] }><span>{bbShortenString(item.Details["Target Email Address"], 25, true)}</span></Tooltip>
              : <Tooltip title={item["Phishing Attack Detail"]["Target Details"]["Email Address"] }><span>{bbShortenString(item["Phishing Attack Detail"]["Target Details"]["Email Address"] , 25, true)}</span></Tooltip>

      // const originVector = isBasicItem
      //     ? item.Details["Attack Origin Ip Address"]
      //     : item["Perimeter Attack Detail"]["Attack Origination Ip"]
      // const originCampaign = isBasicItem
      //     ? item.Details["Source Email Address"]
      //     : item["Phishing Attack Detail"]["Phishing Profile"]["Sender"]["Username"]
      //
      // const targetVector = isBasicItem
      //     ? "Fetch Details..."
      //     : item["Perimeter Attack Detail"]["Attack Vector"]["Fqdn"]
      // const targetCampaign = isBasicItem
      //     ? item.Details["Target Email Address"]
      //     : item["Phishing Attack Detail"]["Target Details"]["Email Address"]

    return (
        {
            id: item.id,
            bbFrontendClasses: item.bbFrontendClasses,
            bbFrontendStyles: item.bbFrontendStyles,
            // Breach: <Tooltip title={attack["Access Gained"] ? `Attack achieved breach: ${bbFormattedDateString(attack["Access Gained DateTime"], "long")}` : "This attack was blocked by your defenses; it did not cause a breach."}><span>{attack["Access Gained"] ? <ExitToAppSharpIcon className={"text-danger"}/> : <BBIconShieldBounce className={"text-success"}/>}</span></Tooltip>,
            Date: item["Start DateTime"]
                    ? <Tooltip title={bbFormattedDateString(item["Start DateTime"], "long")}><span>{bbFormattedDateString(item["Start DateTime"], "monthDayTime")}</span></Tooltip>
                    : <Tooltip title={bbFormattedDateString(item["Access Gained DateTime"], "long")}><span>{bbFormattedDateString(item["Access Gained DateTime"], "monthDayTime")}</span></Tooltip>,
            Status: <Tooltip title={`Status: ${item.Status.Description}`}>{statusIcon()}</Tooltip>,
            Description: item.Status.Description,
            Origin: originComponent,
            Target: targetComponent,
        }
    )
  };

  const customTableSortFunction = ((a, b) => {
      //(a.Status.Name === "Ongoing" ? 1 : 0) - (b.Status.Name === "Ongoing" ? 1 : 0) ||
      //bbDangerousStringToDate(b["Access Gained DateTime"]) - bbDangerousStringToDate(a["Access Gained DateTime"])
      //
      return (b.Status.Name === "Ongoing" ? 1 : 0) - (a.Status.Name === "Ongoing" ? 1 : 0) || bbDangerousStringToDate(b["Access Gained DateTime"]) - bbDangerousStringToDate(a["Access Gained DateTime"])
  });

  //takes the item and returns a style object to be applied to that object
  const customRowStyle = (item) => {
      if (item.Status.Name === "Ongoing") {
          return {
              Classes: null, //"bg-light-gray",
              Styles: null //{backgroundColor : "red"}
          }
      } else {
          return null
      }
  }

    const tableDataAsArray = (data, sortFunction = null) => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);

        //assign an id value to each item since conversion to array might strip the id
        for (const item in data) {
            // console.log("Added ", item, "to the array datetime is , ", bbDangerousStringToDate(data[item]["Access Gained DateTime"]))
            //add custom styles while here
            const styles = customRowStyle(data[item])
            if (styles && styles.Classes) {
                data[item].bbFrontendClasses = styles.Classes
            }
            if (styles && styles.Styles) {
                data[item].bbFrontendStyles = styles.Styles
            }

            data[item].id = item;
        }

        const sortable = [];
        for (const item in data) {
            sortable.push(data[item]);
        }

        // console.log("about to sort", sortable )

        if (sortFunction) {
            sortable.sort(sortFunction);
        }

        //sorted, now map it
        const mappedAndSortedTableArray = sortable.map(customDataMap);

        return mappedAndSortedTableArray;
    }


  if (breachAttacks && !localLoading) {
    // console.log("VulnTargetsTable loading is finished here is the customers in the store", customers, "and table data", tableDataAsArray(), " and vulnerableTargets is: ", vulnerableTargets)
    return (
        <div  >
            <ArrayDataTable tableData={tableDataAsArray(breachAttacks, customTableSortFunction)} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} maxRecordsDisplayOverride = {totalNumBreaches}/>
        </div>
    );
  } else if (localLoading) {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} loading={true} numSkeletonRows={2}/>
        </div>
    );

  } else {
    return (
        <div className={""} >
            <ArrayDataTable tableData={null} columnHeaders={userTableHeadings} overrideRowsPerPage = {targetsBatchSize} title={title} loading={true} numSkeletonRows={2}/>
        </div>

    );
  }


}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer